import { store } from '@/store'
import { getGoalCollectionDatasets } from './getGoalCollectionDatasets'
import { getGoalCollectionCategories } from '@/composables/utils'
import { getCollectionTitle } from '@/composables/goalCollections/utils'
/**
 * Fetches goal collections for project creation
 * ENHANCES the goal collections by adding datasets and categories
 * @param {Number|null} countryId - Optional country ID to filter collections
 * @param {Number|null} frameworkId - Optional framework ID to filter collections
 * @returns {Promise<Array>} - Array of goal collections
 */
export default async function findGoalCollections (countryId = null, frameworkId = null, origin = null) {
  console.log('!! findGoalCollections', countryId, frameworkId, origin)
  try {
    // Filter collections based on parameters
    let { data: collections } = await store.dispatch('goal-collections/find')

    // Filter by country if provided
    /* if (countryId) {
      collections = collections.filter(collection => collection.countryId === countryId)
    } */

    // Filter by framework if provided
    if (frameworkId) {
      collections = collections.filter(collection => collection.frameworkId === frameworkId)
    }
    // Load all goal-collections-sub-categories
    await store.dispatch('goal-collections-sub-categories/find', {
      query: {
        goalCollectionId: { $in: collections.map(collection => collection.id) },
      },
    })
    const results = collections.map(collection => getGoalCollectionDatasets(collection))
    return collections
      .map((collection, index) => ({
        ...collection,
        title: getCollectionTitle(collection),
        datasets: results[index],
        categories: getGoalCollectionCategories(collection),
      }))
      .sort((a, b) => a.id - b.id)
  } catch (error) {
    console.error('!!Error fetching goal collections:', error)
    return []
  }
}
